// $(window).on('load', function() {

// })

$(function(){
  // HOME
  if( $('body#home').length ){

    console.log('is home')

    // sec-main
    //------------------------------------------------------------
    var slickMain = $('#main');
    var $t, header, band, mainbg;

    // $(".view", slickMain).slick({
    //   slidesToShow: 1,
    //   autoplay: true,
    //   pauseOnHover: false,
    //   pauseOnDotsHover: true,
    //   fade: true,
    //   arrows: false,
    //   dots: true,

    //   customPaging: function(slider, i) {
    //     return '<p>'+ (i + 1) +'</p>';
    //   },

    //   onInit: function(){
    //     setTimeout(function(){
    //       $t = $(".item.slick-active", slickMain);
    //       header = $t.data("header");
    //       band = $t.data("band");
    //       mainbg = $t.data("bg");
    //       //
    //       $("#header").attr("data-color", header);
    //       $("html").attr("data-color", header);
    //     }, 10);
    //   },

    //   onBeforeChange: function(){
    //     setTimeout(function(){
    //       $t = $(".item.slick-active", slickMain);
    //       header = $t.data("header");
    //       band = $t.data("band");
    //       mainbg = $t.data("bg");
    //       //
    //       $("#header").attr("data-color", header);
    //       $("html").attr("data-color", header);
    //     }, 10);
    //   }
    // });

    // sec-gallery
    //------------------------------------------------------------
    // var slickWrap = $(".sec-gallery");
    // // slick itemから view側のhtmlを生成
    // $(".slick-cont .item", slickWrap).each(function(i){
    //   var $t = $(this);
    //   var href = $("a", this).attr("href");
    //   var cid = $(this).data("cid");
    //   var bgi = $(this).data("main");
    //   var elm = $('<div class="photo" data-cid="'+ cid +'"><a class="img" href="'+ href +'" target="_blank"></a></div>');
    //   $(".img", elm).css("background-image", "url("+ bgi +")");
    //   $(".view", slickWrap).append(elm);

    //   if ( i === 0 ) {
    //     slickWrap.attr("data-current", cid);
    //     $t.addClass("current");

    //     // cidが一致するものをcurrentに
    //     $(".slick-cont .item[data-cid='"+ cid +"']", slickWrap).addClass("current");
    //     $(".photo[data-cid='"+ cid +"']", slickWrap).addClass("current");
    //   }
    // });

    // $(".slick-cont", slickWrap).slick({
    //   infinite: true,
    //   slidesToShow: 5,
    //   slidesToScroll: 1,
    //   speed: 400,
    //   vertical: true,
    //   autoplay: true,
    //   autoplaySpeed: 3000,
    //   responsive: true,
    //   prevArrow: '<p class="slick-prev">prev</p>',
    //   nextArrow: '<p class="slick-next">next</p>',

    //   onAfterChange: function(){
    //     var cid = $(".slick-cont .item.slick-active:eq(0)").data("cid");

    //     // 一旦 currentをクリア
    //     $(".slick-cont .item", slickWrap).removeClass("current");
    //     $(".photo", slickWrap).removeClass("current");

    //     // cidが一致するものをcurrentに
    //     $(".slick-cont .item[data-cid='"+ cid +"']", slickWrap).addClass("current");
    //     $(".photo[data-cid='"+ cid +"']", slickWrap).addClass("current");
    //   }
    // });

    // $(".slick-cont .item, .bts-always > li", slickWrap).hover(
    //   function(){
    //     var cid = $(this).data("cid");
    //     slickWrap.attr("data-current", cid);
    //     $(".photo", slickWrap).removeClass("active");
    //     $(".photo[data-cid='"+ cid +"']", slickWrap).addClass("active");
    //   },
    //   function(){
    //     $(".photo", slickWrap).removeClass("active");
    //   }
    // );

    // top__cv__banner
    //------------------------------------------------------------
    var len = $('.top__cv__banner .banner').length;
    if(len > 3){
      $('.top__cv__banner').addClass('is-many');
    }

    // js-photocontest-banner
    //------------------------------------------------------------
    $('.js-photocontest-banner').each(function(){
      var self = $(this)
      $.ajax({
        type: 'GET',
        url: '//shigaphotocon.biwako-visitors.jp/getBannerJsonP',
        // crossDomain: true,
        dataType: 'jsonp',
        jsonpCallback: 'getBanner',
        headers: {
          'Authorization': 'Basic Yml3YWtvOnRlc3Q=',
        },
        success: function(json){
          // console.log(json.url);
          self.css({
            'background-image': 'url('+ json.url +')'
          })
        }
      })
    });

    // fb
    //------------------------------------------------------------
    var fbSize = 290;

    if( $('html').is('.win, .mac') ){
      fbSize = 480;
    }
    $('.fb-like-box').attr('data-width', fbSize);

    // toggle posts
    //------------------------------------------------------------
    $('.toggle-posts').on('tap', function(){
      var that = $(this).parent();
      $('.posts', that).toggleClass('active');
    });

    // sp
    //------------------------------------------------------------
    $('.toggle-posts.btn').toggleSwitch()
  }
});



// WEBPACK FOOTER //
// ./_src/js/cont/top.js